import type { Components, Theme } from "@mui/material/styles";

export const MuiTableCell: Components<Theme>["MuiTableCell"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      borderStyle: "solid",
      borderWidth: "0 0 1px 0",
      borderColor: theme.palette.divider,
      borderBottomColor: theme.palette.divider,
      padding: theme.spacing(1),
      "&.CellLayout-cell": {
        "&:first-of-type": {
          paddingLeft: theme.spacing(1),
        },
      },
      "&.CellLayout-cell.MuiTableCell-head": {
        "&:first-of-type": {
          paddingLeft: theme.spacing(1),
        },
      },
    }),
    head: {
      fontSize: "0.875rem",
      textTransform: "none",
    },
    footer: ({ theme }) => ({
      fontSize: "0.875rem",
      color: theme.palette.text.primary,
    }),
  },
};
